module.exports = __webpack_public_path__ + "img/logo-bili.b2f8d1a7.png";